import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, href = "/dashboard", sx, ...other }, ref) => {
  const logo = (
    <Box
      component="img"
      src="/assets/logo/logo_single.png"
      sx={{ width: 100, height: 30, cursor: 'pointer', ...sx  }}
      {...other}
    />
  );


  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href={href} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
